import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeedbackRequestListSliceProps, ReceivedRequest } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getAllReceivedRequestsByMember = createAsyncThunk(
  "admin/feedback/requests/received",
  async (params: FeedbackRequestListSliceProps, storeActions) => {
    const url = `api/v1/admin/member/requests/received?memberId=${params.memberId}&offSet=${params.offSet}&count=${params.count}&status=${params.status}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const allReceivedRequestsByMemberSlice = createSlice({
  name: "allReceivedRequestsByMember",
  initialState: {
    status: null as number | null,
    text: null as string | null,
    data: null as Array<ReceivedRequest> | null,
    loading: false as boolean,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllReceivedRequestsByMember.fulfilled, (state, action) => {
      state.status = action.payload.status;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
      state.loading = false;
    });
    builder.addCase(getAllReceivedRequestsByMember.pending, (state) => {
      state.loading = true;
      state.status = null;
      state.text = null;
      state.data = null;
    });
    builder.addCase(getAllReceivedRequestsByMember.rejected, (state) => {
      state.status = 503;
      state.text = null;
      state.data = null;
      state.loading = false;
    });
  },
});

export const { clearData } = allReceivedRequestsByMemberSlice.actions;

export default allReceivedRequestsByMemberSlice;
